// extracted by mini-css-extract-plugin
export var form = "_c2-0";